import { Student } from '~/services/types';

export type Tab = 'overview' | 'customMessages' | 'dataLog';

const TAB_TO_SLUG: Record<Tab, string> = {
  overview: 'overview',
  customMessages: 'custom-messages',
  dataLog: 'data-log',
};

export const SLUG_TO_TAB: Record<string, Tab> = {
  overview: 'overview',
  'custom-messages': 'customMessages',
  'data-log': 'dataLog',
};

// Convert a voice name to a URL-safe slug. Strips diacritics, lowercases, and
// replaces runs of non-alphanumerics with hyphens. e.g. "Mary-Jane O'Brien" → "mary-jane-o-brien".
export function slugifyVoiceName(name: string): string {
  return name
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

// Returns the unique student whose slugified voice name matches; undefined for 0 or 2+ matches
// (uniqueness is case- and whitespace-insensitive per period, so a slug collision means stale data).
export function findStudentBySlug(students: Student[], slug: string): Student | undefined {
  const matches = students.filter((s) => slugifyVoiceName(s.voiceName) === slug);
  return matches.length === 1 ? matches[0] : undefined;
}

export function getRosterPath(periodShortName: string): string {
  return `/review/${periodShortName}/students`;
}

export function getStudentDataPath(periodShortName: string, voiceName: string, tab: Tab = 'overview'): string {
  const slug = slugifyVoiceName(voiceName);
  if (tab === 'overview') {
    return `/review/${periodShortName}/students/${slug}`;
  }
  return `/review/${periodShortName}/students/${slug}/${TAB_TO_SLUG[tab]}`;
}
